"use server";

import { auth } from "@/auth";
import type { ActionResult } from "@/types/server-action";
import { prisma } from "@/prisma";
import type { SaleTypeDecisionResult } from "@/lib/cat/sale-type-decision.types";
import { determineRetailSaleType } from "@/lib/cat/sale-type-rules";

export async function determineSaleType(
  draftId: number,
): Promise<ActionResult<SaleTypeDecisionResult>> {
  try {
    const session = await auth();
    if (!session) {
      return { success: false, message: "Non authentifié." };
    }
    const draft = await prisma.draft.findUnique({
      where: { id: draftId },
      select: {
        clientEmail: true,
        clientId: true,
        fundingType: true,
        isLeased: true,
        kvps: true,
        otherLeasingType: true,
        rentSale: true,
        siretInput: true,
        vwfsType: true,
      },
    });

    if (!draft) {
      return {
        success: true,
        data: {
          saleTypeCode: "INDÉTERMINÉ",
          status: "fallback",
          message: "Brouillon introuvable.",
          conditionsTrail: [],
          forcedDecisions: [],
        },
      };
    }

    const decision = determineRetailSaleType(draft);
    return { success: true, data: decision };
  } catch (error) {
    console.error("[determineSaleType]", error);
    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
